import React, { useState } from "react";

const ProfessionalTrainingSchedule = ({ onClose }) => {
    const [weekType, setWeekType] = useState("70% of Max Week");

    const handlePrint = () => {
        window.print();
    };

    const schedules = {
        "70% of Max Week": {
            "Monday": [
                "Bench Press - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Dips - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Shoulder - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Side Pressure - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Fingers - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Finger Static - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Wrist - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Wrist Static - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Back Pressure (Hummer Long Moves) - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Pronation With Handle - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Pronation With Belt - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Back Pressure + Riser With Belt - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Back Pressure With Belt - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Riser - 5 Sets (10-12 Rep first, 2-3 Rep last)"
            ],
            "Tuesday": "Table Sparring",
            "Wednesday": [
                "Biceps Pull Ups - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Rope Climbing - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Dumbbell Rows - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Back On Cable Machine - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Supination - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Side Pressure - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Biceps Curl With Bar - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Biceps On Skot - 5 Sets (10-12 Rep first, 2-3 Rep last)"
            ],
            "Thursday": "Table Sparring",
            "Friday": [
                "Neutral Grip Pull Up - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Fingers - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Fingers Static - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Wrist - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Wrist Static - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "French Bar Long Move - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Pronation - 5 Sets (10-12 Rep first, 2-3 Rep last)",
                "Back Pressure Or Middle With Belt - 5 Sets (10-12 Rep first, 2-3 Rep last)"
            ],
            "Saturday": "Table Sparring",
            "Sunday": "Rest"
        },
        "Max Effort Week": {
            "Monday": [
                "Bench Press - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Dips - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Shoulder - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Side Pressure - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Fingers - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Finger Static - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Wrist - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Wrist Static - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Back Pressure (Hummer Long Moves) - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Pronation With Handle - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Pronation With Belt - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Back Pressure + Riser With Belt - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Back Pressure With Belt - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Riser - 5 Sets (5-6 Rep first, 1 Rep last)"
            ],
            "Tuesday": "Table Sparring",
            "Wednesday": [
                "Biceps Pull Ups - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Rope Climbing - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Dumbbell Rows - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Back On Cable Machine - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Supination - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Side Pressure - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Biceps Curl With Bar - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Biceps On Skot - 5 Sets (5-6 Rep first, 1 Rep last)"
            ],
            "Thursday": "Table Sparring",
            "Friday": [
                "Neutral Grip Pull Up - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Fingers - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Fingers Static - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Wrist - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Wrist Static - 5 Sets (5-6 Rep first, 1 Rep last)",
                "French Bar Long Move - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Pronation - 5 Sets (5-6 Rep first, 1 Rep last)",
                "Back Pressure Or Middle With Belt - 5 Sets (5-6 Rep first, 1 Rep last)"
            ],
            "Saturday": "Table Sparring",
            "Sunday": "Rest"
        }
    };

    return (
        <div className="max-w-3xl mx-auto p-6 bg-white rounded-lg shadow-lg print:bg-white print:shadow-none print:w-full">
            <div className="flex justify-between print:hidden">
                <button onClick={onClose} className="text-gray-500 hover:text-gray-800 focus:outline-none">✕</button>
                <button onClick={handlePrint} className="text-baseBlue hover:text-gray-600 font-semibold text-xs">Print 🖨️</button>
            </div>
            <div className="mt-4 flex justify-center print:hidden">
                <select value={weekType} onChange={(e) => setWeekType(e.target.value)} className="p-2 border rounded-md">
                    <option>70% of Max Week</option>
                    <option>Max Effort Week</option>
                </select>
            </div>
            <h1 className="text-2xl font-bold text-center text-gray-800 mt-4">Pro Training Schedule</h1>
            <h2 className="text-xl font-semibold text-center text-gray-700 mt-4">{weekType}</h2>
            <div className="mt-6">
                {Object.entries(schedules[weekType]).map(([day, activities], index) => (
                    <div key={index} className="mb-6 p-4 bg-gray-100 rounded-lg">
                        <h3 className="text-lg font-semibold text-gray-800">{day}</h3>
                        {typeof activities === "string" ? (
                            <p className="text-gray-600">{activities}</p>
                        ) : (
                            <ul className="mt-2 space-y-2">
                                {activities.map((activity, i) => (
                                    <li key={i} className="p-3 bg-white rounded-lg shadow">{activity}</li>
                                ))}
                            </ul>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProfessionalTrainingSchedule;
